"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flags_constants_1 = __importDefault(require("./flags.constants"));
/**
 * Helper function that will return true, if input
 * is null or undefined and false otherwise.
 */
function isNullOrUndefined(o) {
    return typeof o === 'undefined' || o === null;
}
/**
 * Class manages a list of features
 */
var Manager = /** @class */ (function () {
    function Manager(items) {
        this._items = Manager.asArray(items);
    }
    Object.defineProperty(Manager, "FEATURES", {
        get: function () {
            return flags_constants_1.default;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Function creates new instance of FeatureManager class
     * with
     */
    Manager.create = function (items) {
        return new Manager(items);
    };
    /**
     * Function will convert input Feature into array of Features.
     */
    Manager.asArray = function (item) {
        if (Array.isArray(item)) {
            return item.map(Manager.asFeature);
        }
        return [Manager.asFeature(item)];
    };
    /**
     * Function will convert FeatureCompatible input
     * parameter into Feature.
     */
    Manager.asFeature = function (item) {
        if (typeof item === 'string')
            return {
                name: item,
                enabled: true,
            };
        return item;
    };
    /**
     * Function will return a list of ids for specified features.
     */
    Manager.asIds = function (items) {
        return items.map(function (o) { return o.name; });
    };
    /**
     * Function will return true if all requested
     * features are enabled and false otherwise.
     */
    Manager.prototype.enabled = function (item) {
        var arr = Array.isArray(item) ? item : [item];
        var features = this.filter(arr);
        if (features.length !== arr.length)
            return false;
        for (var i = 0; i < features.length; i++) {
            if (!features[i].enabled)
                return false;
        }
        return true;
    };
    /**
     * Function returns a list of registered features.
     */
    Manager.prototype.items = function () {
        return this._items;
    };
    /**
     * Filters current features based on input filter.
     */
    Manager.prototype.filter = function (filterOrIds) {
        var filter = Array.isArray(filterOrIds) ? { ids: filterOrIds } : filterOrIds;
        return this.items().filter(function (item) {
            // filter by ids
            if (filter.ids && !filter.ids.includes(item.name)) {
                return false;
            }
            // filter by enabled flag
            return isNullOrUndefined(filter.enabled) || filter.enabled === item.enabled;
        });
    };
    return Manager;
}());
exports.default = Manager;
